import { render, staticRenderFns } from "./technician-ratings.vue?vue&type=template&id=30e638f6"
import script from "./technician-ratings.vue?vue&type=script&lang=js"
export * from "./technician-ratings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports